const ContentfulConfigs = {
  host: window.PUBLIC_CONFIG.contentful.host,
  accessToken: window.PUBLIC_CONFIG.contentful.spaces.grailed.access_token,
  spaceId: window.PUBLIC_CONFIG.contentful.spaces.grailed.space_id,
};
export default ContentfulConfigs;
